// @flow
import React, { useCallback, useRef, useState } from "react";
import Board from "react-trello";

import { Box, CircularProgress } from "@mui/material";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";

import DataTable from "../../../../components/Tables/DataTable";
import KanbanCard from "../../../../components/Cards/KanbanCard";
import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";

import colors from "../../../../assets/theme/light/colors";
import Mnemonic from "../../../../Mnemonics.json";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import {
	getOptionPriorityIcon,
	SubtaskIcon,
} from "../../../../components/Icon";

import { enqueueSnackbar } from "notistack";
import useAuth from "../../../../hooks/useAuth";
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import useMutationAuth from "../../../../hooks/useMutationAuth";
import {
	GET_TASK_BOARD_DATA,
	UPDATE_TASK_QUICK,
} from "../../../../graphql/task";
import { GET_STATUS_COLOR } from "../../../../graphql/taskStatus";
import { useParams } from "react-router-dom";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import { useTaskFilters } from "./UseTaskFilters";
export function TaskBoard({
	// defaultFilters,
	// setDefaultFilters,
	fromTicket,
	fromSubtask,
	fromProjectTasks,
	handleSaveUserTableFilters,
	openSavedFilters,
	setOpenSavedFilters,
	selectedFilterGuid,
	handleCloseModal,
	parentGuid,
	refetch,
	refetchStatus,
	doing,
	fromTenant,
	fromBacklog,
	fromProject,
	setDoing,
	parentName,
	chipFilters,
	setChipFilters,
	statusLoading,
	employeesList,
	taskStateList,
	teams_list,
	projectsList,
	areaList,
	taskList,
	teamsLoading,
	projectLoading,
	employeeLoading,
	areaLoading,
	taskLoading,
	employeeWait,
	showAsBoard,
	setShowAsBoard,
}) {
	const {
		isEmployee,
		storeUserGuid,
		storeUserTenant,
		userRoles,
		storeUserTeams,
	} = useAuth();
	const { isAdmin, manageTimeEntry } = userRoles;
	const { t } = useTranslation();
	const { pID } = useParams();
	const count = useRef(0);
	const {
		defaultFilters,
		filterState,
		filtersObject,
		selectedProject,
		setDefaultFilters,
		setFilterState,
		setSelectedProject,
	} = useTaskFilters({
		fromProject,
		fromTicket,
		fromTenant,
	});
	const { cfunction: updateTaskQuickData } = useMutationAuth(
		UPDATE_TASK_QUICK,
		"UpdateTaskQuick"
	);

	const { mfunction: getAlltaskStatusColor } = useLazyQueryAuth(
		GET_STATUS_COLOR,
		"GetStatusColors"
	);

	// Local state
	const [boardData, setBoardData] = useState({ lanes: [] });
	const [openModal, setOpenModal] = useState(false);
	const [selectedTask, setSelectedTask] = useState(null);
	// const [selectedProject, setSelectedProject] = useState([]);
	const [rowGuid, setRowGuid] = useState("");

	const [selectedTaskName, setSelectedTaskName] = useState("");

	const [projectName, setProjectName] = useState();

	const [showQuickFilters, setShowQuickFilters] = useState(() => {
		const savedState = localStorage.getItem("showQuickFilters");
		return savedState === "true";
	});
	const [projectID, setProjectID] = useState();

	const [type, setType] = useState(null);
	const [filters, setFilters] = useState(null);
	const [loading, setLoading] = useState(false);

	const [parent, setParent] = useState(null);
	const [search, setSearch] = useState("");

	// const [filterState, setFilterState] = useState([]);
	const addNewSubtask = useRef(false);

	const { loading: loadTasks, refetch: refetchTasks } = useQueryAuth(
		GET_TASK_BOARD_DATA,
		"GetTaskStatusesWithTasks",
		{
			variables: {
				model: {
					tenantGuid: storeUserTenant,
					keyWord: search,
					filters: defaultFilters,
					userID: storeUserGuid,
					onlyTasks: chipFilters.onlyTasks,
					onlySubtasks: chipFilters.onlySubtasks,
					highPriority: chipFilters.doing,
					myProjectsTasks: chipFilters.myProjectTasks,
					projectGuid: fromTicket || fromProjectTasks ? pID : null,
					myTasks: chipFilters.assignedToMe,
					myTeamsTasks: chipFilters.assignedToMyTeam,
				},
			},
		},
		{
			onCompleted: (data) => {
				const statuses =
					data.GetTaskStatusesWithTasks.tasksStatusesWithTasksList
						?.taskStatuses || [];
				getAlltaskStatusColor({}, (colorResp) => {
					const statusColors =
						colorResp.GetStatusColors?.statusColors || [];

					// 4) now build lanes with correct colorCodes
					const lanes = statuses.map((st) => {
						const colorCode =
							statusColors.find(
								(c) =>
									c.statusColorGuid ===
									st?.statusColor?.statusColorGuid
							)?.colorCode ?? "#ccc";

						return {
							id: st.taskStatusGuid,
							title: st.description,
							label: `${st.tasks.length}`,
							style: {
								borderTop: `5px solid ${colorCode}`,
								borderTopLeftRadius: "5px",
								borderTopRightRadius: "5px",
								backgroundColor: "#F0F0F0",
								boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
								height: "100%",
								maxHeight: "70vh",
							},
							cards: st.tasks.map((task) => ({
								id: task.guid,
								title: task.title,
								metadata: task,
							})),
						};
					});

					setBoardData({ lanes });
				});
			},
		}
	);

	const handleAddNew = (type) => {
		if (type === "subtask") {
			setSelectedTask(null);
			setSelectedProject(null);
			setSelectedTaskName(null);
			setProjectName(null);
			setType(type);
			setParent(null);
			setTimeout(() => {
				setOpenModal(true);
			}, 500);
		} else {
			setSelectedTask(null);
			setSelectedProject(null);
			setSelectedTaskName(null);
			setProjectName(null);
			setType(type);
			setParent(null);
			setTimeout(() => {
				setOpenModal(true);
			}, 500);
		}
	};
	const customButtons = [
		{
			label: "table.list",
			disabled: loadTasks || loading,
			condition: true,
			icon: true,
			iconButton: (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					width="24"
					height="24"
					stroke-width="2"
				>
					<path d="M9 6h11"></path>
					<path d="M12 12h8"></path>
					<path d="M15 18h5"></path>
					<path d="M5 6v.01"></path>
					<path d="M8 12v.01"></path>
					<path d="M11 18v.01"></path>
				</svg>
			),
			handleClick: () => {
				setShowAsBoard(false);
			},
		},
		{
			label: "dashboard.subtask.addNew",
			handleClick: () => {
				handleAddNew("subtask");
			},
			condition: isEmployee !== Mnemonic.ResourceTypes.External,
			icon: true,
			iconButton: <SubtaskIcon color={colors.light_logo_blue} />,
		},
		{
			label: "dashboard.task.addNew",
			handleClick: () => {
				handleAddNew("task");
			},
			condition:
				isEmployee !== Mnemonic.ResourceTypes.External &&
				manageTimeEntry === "M" &&
				!fromSubtask,
			icon: true,
			iconButton: (
				<AddCircleRoundedIcon
					sx={{
						color: colors.light_logo_blue,
						fontSize: "28px !important",
					}}
				/>
			),
		},
	];

	const handleRefetchTree = useCallback(async () => {
		setLoading(true);
		await refetchTasks(
			{
				variables: {
					model: {
						tenantGuid: storeUserTenant,
						keyWord: search,
						filters: defaultFilters,
						userID: storeUserGuid,
						onlyTasks: chipFilters.onlyTasks,
						onlySubtasks: chipFilters.onlySubtasks,
						highPriority: chipFilters.doing,
						myProjectsTasks: chipFilters.myProjectTasks,
						projectGuid: fromTicket || fromProjectTasks ? pID : null,
						myTasks: chipFilters.assignedToMe,
						myTeamsTasks: chipFilters.assignedToMyTeam,
					},
				},
			},
			{
				onCompleted: (data) => {
					const statuses =
						data.GetTaskStatusesWithTasks.tasksStatusesWithTasksList
							?.taskStatuses || [];
					getAlltaskStatusColor({}, (colorResp) => {
						const statusColors =
							colorResp.GetStatusColors?.statusColors || [];

						// 4) now build lanes with correct colorCodes
						const lanes = statuses.map((st) => {
							const colorCode =
								statusColors.find(
									(c) =>
										c.statusColorGuid ===
										st?.statusColor?.statusColorGuid
								)?.colorCode ?? "#ccc";

							return {
								id: st.taskStatusGuid,
								title: st.description,
								label: `${st.tasks.length}`,
								style: {
									borderTop: `5px solid ${colorCode}`,
									borderTopLeftRadius: "5px",
									borderTopRightRadius: "5px",
									backgroundColor: "#F0F0F0",
									boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
								},
								cards: st.tasks.map((task) => ({
									id: task.guid,
									title: task.title,
									metadata: task,
								})),
							};
						});

						setBoardData({ lanes });
						setLoading(false);
					});
				},
			}
		);
		setLoading(false);
	}, [
		chipFilters.assignedToMe,
		chipFilters.assignedToMyTeam,
		chipFilters.doing,
		chipFilters.myProjectTasks,
		chipFilters.onlySubtasks,
		chipFilters.onlyTasks,
		defaultFilters,
		fromProjectTasks,
		fromTicket,
		getAlltaskStatusColor,
		pID,
		refetchTasks,
		search,
		storeUserGuid,
		storeUserTenant,
	]);
	// Quick update mutation
	const updateTaskQuick = useCallback(
		(taskGuid, statusGuid) => {
			updateTaskQuickData(
				{
					variables: {
						model: {
							taskGuid,
							userID: storeUserGuid,
							statusGuid,
							key: uuidv4(),
						},
					},
				},
				(response) => {
					const { errorCode, errorMessage } = response.UpdateTaskQuick;
					if (errorCode) {
						enqueueSnackbar(t(errorMessage), { variant: "error" });
						handleRefetchTree();
					} else {
						enqueueSnackbar(t("board.savedSuccessfully"), {
							variant: "success",
						});
					}
				},
				() => handleRefetchTree()
			);
		},
		[storeUserGuid, updateTaskQuickData, handleRefetchTree, t]
	);

	const components = {
		Card: ({ id, metadata }) => (
			<div className="kanban-drag-handle">
				<KanbanCard
					key={id}
					task={metadata.title}
					taskId={metadata.id}
					taskGuid={metadata.guid}
					type={metadata.parentTaskGuid ? "subtask" : "task"}
					project={metadata.ticket?.project?.title}
					dueDate={metadata.estimatedEndDate}
					priority={metadata.priority}
					actualTime={metadata.actualTime}
					assignedTo={metadata.assignedTo}
					updateTaskQuick={updateTaskQuick}
					storeUserGuid={storeUserGuid}
					refetch={() => {}}
				/>
			</div>
		),
	};

	// const filtersObject = getFiltersObject(
	// 	(fromProject = !fromBacklog),
	// 	projectsList,
	// 	employeesList,
	// 	taskStateList,
	// 	teams_list,
	// 	teamsLoading,
	// 	projectLoading,
	// 	employeeLoading,
	// 	statusLoading,
	// 	isAdmin,
	// 	isManager,
	// 	defaultFilters,
	// 	filterState,
	// 	areaList,
	// 	areaLoading,
	// 	taskList,
	// 	taskLoading,
	// 	setFetchProjects,
	// 	setFetchTasks,
	// 	setFetchAreas,
	// 	setSelectedProject,
	// 	selectedProject,
	// 	prioritiesList
	// );

	const handleOpenModal = (row) => {
		const rowID = Object.keys(rowGuid)[0];
		if (fromSubtask) {
			handleCloseModal();
		}
		setSelectedTask(fromSubtask && !row ? null : row?.task?.taskGuid);
		setSelectedProject(
			fromSubtask ? projectID : row?.task?.ticket?.project?.projectGuid
		);
		setSelectedTaskName(fromSubtask && !row ? null : row?.task?.title);
		setProjectName(
			fromSubtask
				? projectName
				: row?.task?.ticket?.project?.title
				? row?.task?.ticket?.project?.title
				: boardData?.map((x) => x.task).filter((x) => x.guid === rowID)[0]
						?.projectName
				? boardData?.map((x) => x.task).filter((x) => x.guid === rowID)[0]
						?.projectName
				: null
		);
		setType(fromSubtask ? "subtask" : "task");
		addNewSubtask.current = fromSubtask;
		setParent({
			taskGuid: parentGuid,
			title: parentName,
		});
		setTimeout(() => {
			setOpenModal(true);
		}, 500);
	};
	const handleChipClick = (newChipFilters) => {
		let updatedDefaultFilters = { ...defaultFilters };
		let updatedFilterState = [...filterState];

		if (newChipFilters.assignedToMe) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
				employeeIDs: [storeUserGuid],
			};

			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value = [storeUserGuid];
			} else {
				updatedFilterState.push({
					value: [storeUserGuid],
					property: "employeeIDs",
				});
			}

			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				updatedFilterState[teamIndex].value =
					updatedFilterState[teamIndex]?.value || [];
			} else {
				updatedFilterState.push({ value: null, property: "teamsIDs" });
			}
		} else {
			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value = updatedFilterState[
					employeeIndex
				].value?.filter((id) => id !== storeUserGuid);

				if (updatedFilterState[employeeIndex].value?.length === 0) {
					updatedFilterState.splice(employeeIndex, 1);
				}
			}

			// delete updatedDefaultFilters.employeeIDs;
		}

		if (newChipFilters.assignedToMyTeam) {
			const filteredTeams = storeUserTeams?.map((x) => x.team);
			const filteredTeamsGuids = filteredTeams.map((t) => t.teamGuid);

			updatedDefaultFilters = {
				...updatedDefaultFilters,
				teamsIDs: filteredTeamsGuids,
			};

			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				updatedFilterState[teamIndex].value = filteredTeamsGuids;
			} else {
				updatedFilterState.push({
					value: filteredTeamsGuids,
					property: "teamsIDs",
				});
			}

			const employeeIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "employeeIDs"
			);
			if (employeeIndex >= 0) {
				updatedFilterState[employeeIndex].value =
					updatedFilterState[employeeIndex].value?.map(
						(x) => x?.employeeGuid
					) || [];
			} else {
				updatedFilterState.push({ value: null, property: "employeeIDs" });
			}
		} else {
			const teamIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "teamsIDs"
			);
			if (teamIndex >= 0) {
				const existingTeamIDs = updatedFilterState[teamIndex].value || [];
				const filteredTeams = storeUserTeams?.map((x) => x.team);
				const filteredTeamsGuids = filteredTeams.map((t) => t.teamGuid);
				updatedFilterState[teamIndex].value = existingTeamIDs.filter(
					(id) => !filteredTeamsGuids.includes(id)
				);

				if (updatedFilterState[teamIndex].value?.length === 0) {
					updatedFilterState.splice(teamIndex, 1);
				}
			}
		}

		if (newChipFilters.myProjectTasks) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
			};
		}

		if (newChipFilters.highPriority) {
			updatedDefaultFilters = {
				...updatedDefaultFilters,
				priority: null,
			};

			const priorityIndex = updatedFilterState.findIndex(
				(obj) => obj.property === "priority"
			);
			if (priorityIndex >= 0) {
				updatedFilterState[priorityIndex].value = null;
			} else {
				updatedFilterState.push({ value: null, property: "priority" });
			}
		}

		setDefaultFilters(updatedDefaultFilters);
		setFilterState(updatedFilterState);
		// setChipFiltersClicked(!chipFiltersClicked);
	};

	const chips = [
		{
			label: t("ts.AssignedToMe"),
			tooltip: t("ts.assignedtometooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newAssignedToMe = !chipFilters.assignedToMe;
				const newChipFilters = {
					...chipFilters,
					assignedToMe: newAssignedToMe,
					myProjectTasks:
						chipFilters.assignedToMyTeam || newAssignedToMe
							? false
							: true,
				};
				setChipFilters(newChipFilters);
				handleChipClick(newChipFilters);
			},
			color: chipFilters.assignedToMe ? "primary" : "default",
			variant: chipFilters.assignedToMe ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.assignedToMe
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.AssignedToMyTeam"),
			tooltip: t("ts.assignedtomeyteamtooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newAssignedToMyTeam = !chipFilters.assignedToMyTeam;
				const newChipFilters = {
					...chipFilters,
					assignedToMyTeam: newAssignedToMyTeam,
					myProjectTasks:
						chipFilters.assignedToMe || newAssignedToMyTeam
							? false
							: true,
				};
				setChipFilters(newChipFilters);
				handleChipClick(newChipFilters);
			},
			color: chipFilters.assignedToMyTeam ? "primary" : "default",
			variant: chipFilters.assignedToMyTeam ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.assignedToMyTeam
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.OnlyTasks"),
			tooltip: t("ts.taskstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				setChipFilters((prevFilters) => {
					const newOnlyTasks = !prevFilters.onlyTasks;
					const newOnlySubtasks = prevFilters.onlySubtasks;

					if (!newOnlyTasks && !newOnlySubtasks) {
						return {
							...prevFilters,
							onlyTasks: false,
							onlySubtasks: true,
						};
					}

					return {
						...prevFilters,
						onlyTasks: newOnlyTasks,
					};
				});
			},
			color: chipFilters.onlyTasks ? "primary" : "default",
			variant: chipFilters.onlyTasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.onlyTasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.OnlySubtasks"),
			tooltip: t("ts.subtaskstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				setChipFilters((prevFilters) => {
					const newOnlySubtasks = !prevFilters.onlySubtasks;
					const newOnlyTasks = prevFilters.onlyTasks;

					if (!newOnlySubtasks && !newOnlyTasks) {
						return {
							...prevFilters,
							onlySubtasks: false,
							onlyTasks: true,
						};
					}

					return {
						...prevFilters,
						onlySubtasks: newOnlySubtasks,
					};
				});
			},
			color: chipFilters.onlySubtasks ? "primary" : "default",
			variant: chipFilters.onlySubtasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.onlySubtasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: t("ts.myprojectTasks"),
			tooltip: t("ts.myprojectstooltip"),
			visible: true,
			onClick: () => {
				count.current = count.current + 1;
				const newMyProjectTasks = !chipFilters.myProjectTasks;
				const newChipFilters = {
					...chipFilters,
					myProjectTasks: newMyProjectTasks,
					assignedToMe: newMyProjectTasks
						? false
						: chipFilters.assignedToMe,
					assignedToMyTeam: newMyProjectTasks
						? false
						: chipFilters.assignedToMyTeam,
				};
				setChipFilters(newChipFilters);
				if (
					!newMyProjectTasks &&
					!chipFilters.assignedToMe &&
					!chipFilters.assignedToMyTeam &&
					!isAdmin
				) {
					newChipFilters.assignedToMe = true;
				}
				handleChipClick(newChipFilters);
			},
			color: chipFilters.myProjectTasks ? "primary" : "default",
			variant: chipFilters.myProjectTasks ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: chipFilters.myProjectTasks
						? "white"
						: `${colors.chip_label} !important`,
				},
			},
		},

		{
			tooltip: t("ts.prioritytooltip"),
			icon: getOptionPriorityIcon("High", { marginRight: "-17px" }),
			visible: true,

			onClick: () => {
				count.current = count.current + 1;
				const newChipFilters = {
					...chipFilters,
					highPriority: true,
				};

				handleChipClick(newChipFilters);
				setDoing(!doing);
				setChipFilters((prevFilters) => ({
					...prevFilters,
					doing: !prevFilters.doing,
				}));
			},
			color: doing ? "primary" : "default",
			variant: doing ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: doing ? "white" : `${colors.chip_label} !important`,
				},
			},
		},
		{
			label: openSavedFilters
				? t("ts.hideSavedFilters")
				: t("ts.showSavedFilters"),
			onClick: () => {
				setOpenSavedFilters((oldValue) => !oldValue);
			},
			variant: openSavedFilters ? "filled" : "outlined",
			sx: {
				".MuiButtonBase-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"&.MuiChip-root": {
					border: `1px solid ${colors.chip_border} !important`,
				},
				"& .MuiChip-label": {
					color: openSavedFilters
						? `${colors.icon_button_grey} !important`
						: `${colors.chip_label} !important`,
				},
			},
			visible: true,
		},
	];
	const tablePagination = {
		defaultFilters,
		setDefaultFilters,
		loading: loadTasks || loading,
		search,
		customButtons,
		readOnly: isEmployee === Mnemonic.ResourceTypes.External,
		setSearch,
		handleRefresh: handleRefetchTree,
		disableAddBtn: true,
		searchText: fromTenant
			? "task.list.search.label.fromTenant"
			: "task.list.search.label",
		refetch: handleRefetchTree,
		filtersObject,
		treeTable: true,
		handleOpenModal,
		hideEditColumns: true,
		fetchTableData: handleRefetchTree,
		disableSearchRefetch: true,
	};
	// Render
	return (
		<div>
			<DataTable
				defaultChipFilters={{
					showParents: !!pID,
					assignedToMe: !pID,
					assignedToMyTeam: !pID,
					onlySubtasks: true,
					onlyTasks: true,
					myProjectTasks: !!pID,
					doing: false,
				}}
				handleResetChipFilter={() =>
					setChipFilters({
						showParents: !!pID,
						assignedToMe: false,
						assignedToMyTeam: false,
						onlySubtasks: true,
						onlyTasks: true,
						myProjectTasks: isAdmin ? false : !!pID,
						doing: false,
					})
				}
				handleDefaultFilters={(f) => setFilters(f)}
				quickFilters
				savedFilterFlag={true}
				showUpdateFilterButton={
					selectedFilterGuid !== null &&
					selectedFilterGuid !== undefined &&
					selectedFilterGuid !== ""
				}
				handleUpdateFilter={handleSaveUserTableFilters}
				handleSaveFilter={(args) => {
					handleSaveUserTableFilters(...args);
				}}
				chips={chips}
				chipFilters={chipFilters}
				handleShowQuickFilters={setShowQuickFilters}
				{...tablePagination}
			/>

			{loadTasks || loading ? (
				<Box sx={{ display: "flex", justifyContent: "center", margin: 40 }}>
					<CircularProgress />
				</Box>
			) : (
				<Box
					sx={{
						overflowX: "auto",
						overflowY: "hidden",
						height: "calc(100vh - 250px)",
					}}
				>
					<Board
						style={{ backgroundColor: "transparent", height: "100%" }}
						data={boardData}
						draggable
						laneDraggable={false}
						components={components}
						onCardMoveAcrossLanes={(fromLane, toLane, cardId) => {
							updateTaskQuick(cardId, toLane);
						}}
						onDataChange={(newData) => {
							// newData is the board with cards already moved
							const lanes = newData.lanes.map((lane) => ({
								...lane,
								// reset the count badge to the current number of cards
								label: String(lane.cards.length),
							}));
							setBoardData({ lanes });
						}}
					/>
				</Box>
			)}

			<TaskTabsModal
				showModal={openModal}
				setShowModal={setOpenModal}
				loading={false || statusLoading}
				taskID={selectedTask}
				taskName={selectedTaskName}
				handleChangeTask={setSelectedTask}
				handleChangeProject={setSelectedProject}
				projectID={selectedProject}
				fromProject
				refetch={handleRefetchTree}
				open={JSON.parse(sessionStorage.getItem("unsavedChanges"))}
				modifyFormFlag={() =>
					sessionStorage.setItem("unsavedChanges", "false")
				}
				type={type}
				setType={setType}
				parent={parent}
				taskStatusList={taskStateList}
				data={boardData}
				updateData={setBoardData}
				totalFilters={chipFilters}
				editMode={!addNewSubtask.current}
			/>
		</div>
	);
}
